import Button from '@mui/joy/Button'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'

export const LayerDownButton = ({ onClick }) => (
    <Button
        variant="soft"
        color="neutral"
        onClick={onClick}
        endDecorator={<KeyboardArrowDown />}
    >
        Down
    </Button>
)
